export default __webpack_public_path__ + "static/FS2S-InHub-122-6c3b6773c23c3a5e9d5a3395c2d25829.jpg";